import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ApplicationBanks } from "../authSlice/authSlice";
import { message } from "antd";
import {
  ApplicationBankCardData,
  ApplicationBankList,
  ApplicationBankTatBgStatus,
} from "../../types/applicationBankList.type";
import { ApplicationBankListStatusPreset } from "../../api/applicationBankListApi/applicationBank.api";
import { BgType } from "../../types/application.type";

interface IApplicationsState {
  applicationBanks: ApplicationBankList;
  typeBG: BgType[];
  // startIndex: number;
  last_page: number;
  // scrollPosition: number;
  filter: FilterApplications;
}

interface ResponseAction {
  data: ApplicationBankList;
  last_page: number;
}

interface ChangeStatusDto {
  id: number;
  status: ApplicationBankTatBgStatus;
}

export interface FilterApplications {
  status_preset: ApplicationBankListStatusPreset;
  bg_type: string;
  status: string;
  created_at: string;
  amount_from: string | null;
  amount_to: string | null;
  inn: string;
  application_bank_id: string;
  page: number;

  bank_id: number | null;
}

const initialState: IApplicationsState = {
  applicationBanks: [] as ApplicationBankList,
  typeBG: [],

  last_page: 0,

  filter: {
    page: 1,
    status_preset: "",
    bg_type: "",
    status: "",
    amount_from: null,
    amount_to: null,
    created_at: "",
    inn: "",
    bank_id: null,
    application_bank_id: "",
  },
};

// список заявок
const applicationBankListSlice = createSlice({
  name: "APPLICATION_BANK_LIST_SLICE",
  initialState: initialState,
  reducers: {
    // обновить все заявки
    UP_DATE_APPLICATIONS_ALL: (
      state,
      actions: PayloadAction<ResponseAction, string>
    ) => {
      state.applicationBanks = actions.payload.data.map((item) => ({
        ...item,
        isNewMessage: false,
      }));
      state.last_page = actions.payload.last_page;
    },
    // добавление новой заявки
    ADD_NEW_APPLICATION: (
      state,
      actions: PayloadAction<ApplicationBankCardData, string>
    ) => {
      state.applicationBanks.unshift(actions.payload);
    },
    // обновить статус заявки
    UP_DATE_APPLICATION_STATUS: (
      state,
      actions: PayloadAction<ChangeStatusDto, string>
    ) => {
      state.applicationBanks = state.applicationBanks.map(
        (item: ApplicationBankCardData) => {
          if (item.id === actions.payload.id) {
            return { ...item, status: actions.payload.status };
          }
          return item;
        }
      );
    },
    // добавление заявок с других страниц при нажатии кнопки загрузить ещё
    UP_DATE_APPLICATIONS_WITH_PAGE: (
      state,
      actions: PayloadAction<ResponseAction, string>
    ) => {
      if (actions.payload.data && Array.isArray(actions.payload.data)) {
        state.applicationBanks.push(...actions.payload.data);
        // state.startIndex += 50;
      } else {
        message.error("Ошибка сервера");
      }
    },
    // обновить тип бг
    UP_DATE_APPLICATIONS_TYPE_BG: (state, actions: PayloadAction<BgType[]>) => {
      state.typeBG = actions.payload;
    },
    // UP_DATE_APPLICATIONS_SCROLL: (
    //   state,
    //   actions: PayloadAction<number, string>
    // ) => {
    //   state.scrollPosition = actions.payload;
    // },
    // UP_DATE_APPLICATIONS_START_INDEX: (
    //   state,
    //   actions: PayloadAction<number, string>
    // ) => {
    //   state.startIndex = actions.payload;
    // },
    // отображение на заявке уведомления о новом сообщении в чате
    UP_DATE_IS_NEW_MESSAGE: (
      state,
      actions: PayloadAction<{ id: number; isNewMessage: boolean }>
    ) => {
      if (Array.isArray(state.applicationBanks)) {
        state.applicationBanks = state.applicationBanks.map(
          (item: ApplicationBankCardData) => {
            if (item.id === actions.payload.id) {
              return {
                ...item,
                isNewMessage: actions.payload.isNewMessage,
              };
            } else {
              return item;
            }
          }
        );
      }
    },
    // пометка заявки как прочитанная
    UP_DATE_IS_READ: (
      state,
      actions: PayloadAction<{ id: number; read: boolean }>
    ) => {
      if (Array.isArray(state.applicationBanks)) {
        state.applicationBanks = state.applicationBanks.map(
          (item: ApplicationBankCardData) => {
            if (item.id === actions.payload.id) {
              return {
                ...item,
                read: actions.payload.read,
              };
            } else {
              return item;
            }
          }
        );
      }
    },
    // добавление банка к заявке
    ADD_NEW_BANK: (
      state,
      actions: PayloadAction<{ banks: ApplicationBanks[]; id: number }>
    ) => {
      state.applicationBanks = state.applicationBanks.map(
        (item: ApplicationBankCardData) => {
          if (item.id === actions.payload.id) {
            return { ...item, application_banks: actions.payload.banks };
          }
          return item;
        }
      );
    },
    UP_DATE_FILTER: (
      state,
      action: PayloadAction<Partial<FilterApplications>>
    ) => {
      state.filter = { ...state.filter, page: 1, ...action.payload };
    },
    NEXT_PAGE: (state) => {
      state.filter.page = state.filter.page + 1;
    },
    RESET_FILTER: (state) => {
      state.filter = initialState.filter;
    },
  },
});

// export const selectProfile = (state: RootState) => state.;
export const {
  UP_DATE_APPLICATIONS_ALL,
  UP_DATE_APPLICATIONS_TYPE_BG,
  UP_DATE_APPLICATIONS_WITH_PAGE,
  UP_DATE_IS_NEW_MESSAGE,
  UP_DATE_IS_READ,
  UP_DATE_APPLICATION_STATUS,
  ADD_NEW_APPLICATION,
  ADD_NEW_BANK,
  UP_DATE_FILTER,
  RESET_FILTER,
  NEXT_PAGE,
} = applicationBankListSlice.actions;

export default applicationBankListSlice.reducer;
